// Persistence for the wallet: IndexedDB in the browser (CryptoKey objects are
// stored as non-extractable keys), memory elsewhere (tests, private windows).
export interface KV { get<T>(k: string): Promise<T | undefined>; set(k: string, v: unknown): Promise<void>; del(k: string): Promise<void> }

export function memoryStore(): KV {
  const m = new Map<string, unknown>();
  return { get: async (k) => m.get(k) as any, set: async (k, v) => void m.set(k, v), del: async (k) => void m.delete(k) };
}

export function idbStore(name = "qsv-wallet"): KV {
  if (typeof indexedDB === "undefined") return memoryStore();
  const open = () => new Promise<IDBDatabase>((res, rej) => {
    const r = indexedDB.open(name, 1);
    r.onupgradeneeded = () => r.result.createObjectStore("kv");
    r.onsuccess = () => res(r.result);
    r.onerror = () => rej(r.error);
  });
  const tx = async (mode: IDBTransactionMode, fn: (s: IDBObjectStore) => IDBRequest) => {
    const db = await open();
    return new Promise<any>((res, rej) => {
      const req = fn(db.transaction("kv", mode).objectStore("kv"));
      req.onsuccess = () => res(req.result);
      req.onerror = () => rej(req.error);
    });
  };
  return { get: (k) => tx("readonly", (s) => s.get(k)), set: (k, v) => tx("readwrite", (s) => s.put(v, k)).then(() => {}),
           del: (k) => tx("readwrite", (s) => s.delete(k)).then(() => {}) };
}
